import Head from 'next/head';

/**
 * Inject JSON-LD structured data into <head>.
 *
 * Accepts a single schema object or an array. Falsy values (null/undefined)
 * are filtered out so callers can pass conditional schemas without guards.
 */
const JsonLd = ({ data }) => {
  const schemas = (Array.isArray(data) ? data : [data]).filter(Boolean);

  if (schemas.length === 0) return null;

  return (
    <Head>
      {schemas.map((schema, index) => (
        <script
          key={`jsonld-${index}`}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
        />
      ))}
    </Head>
  );
};

export default JsonLd;
